export const HAVE_IMAGEBITMAP = typeof ImageBitmap !== "undefined";
